import React from 'react';

export default function SettingsTableSkeleton({ columns = 2, rows = 6 }) {
	return (
		<tbody className="settings-table-skeleton">
			{Array.from({ length: rows }).map((_, rowIndex) => (
				<tr
					key={`skeleton-row-${rowIndex}`}
					className="settings-table-skeleton-row">
					{Array.from({ length: columns }).map((__, colIndex) => (
						<td key={`skeleton-cell-${rowIndex}-${colIndex}`}>
							<span
								className="settings-table-skeleton-bar"
								style={{
									width: colIndex === 0 ? '72%' : '48%'
								}}
							/>
						</td>
					))}
				</tr>
			))}
		</tbody>
	);
}
